import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, inject, input, signal } from '@angular/core';
import { AbstractControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BaseFormField } from 'src/app/shared/form/abstracts';
import { StructureField } from 'src/app/shared/modular-survey/interfaces';
import { ModularSurveyForm } from 'src/app/shared/modular-survey/services';

@Component({
  selector: 'app-single-response-field-wrapper',
  standalone: true,
  imports: [
    TranslateModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: SingleResponseFieldWrapperComponent 
    },
  ],
  templateUrl: './single-response-field-wrapper.component.html',
  styleUrls: ['./single-response-field-wrapper.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SingleResponseFieldWrapperComponent extends BaseFormField<string> {
  // Inputs
  public field = input<StructureField>();
  public form = input.required<FormGroup>();
  public formControlName = input.required<string>();
  
  // Service injections
  private _cdr = inject(ChangeDetectorRef);
  private _modularSurveyFormService = inject(ModularSurveyForm);
  
  // Computed properties
  private formControl = computed(() => this.form().get(this.formControlName()));
  private _selectedValue = signal<string | null>(null);

  // Local signal states
  protected showErrorMessage = signal<boolean>(false);
  
  // Effects
  markAllFieldsAsTouched = effect(() => {
    const control = this.formControl();
    this._markFieldsAsTouched(control, this._cdr);
  }, { allowSignalWrites: true });
  
  // Methods
  protected isSelected(option: string): boolean {
    return this._selectedValue() === option;
  }

  override writeValue(value: string): void {
    super.writeValue(value);
    this._selectedValue.set(value);
  }

  protected selectOption(option: string): void {
    this._selectedValue.set(option);
    this.formControl()?.setValue(option);
    this.formControl()?.markAsTouched();
    this.showErrorMessage.set(false);
  }
  
  private _markFieldsAsTouched(control: AbstractControl | null, cdr: any): void {
    if (this._modularSurveyFormService.markAllFormFieldsAsTouched()) {
      this._modularSurveyFormService.markFieldAsTouched(control);

      if (this._modularSurveyFormService.isInvalidField(control)) {
        this.showErrorMessage.set(true);
      }
      cdr.detectChanges();
    }
  }
}
